import { Box, Grid, Typography } from "@mui/material"
import logo from '../assets/logo.png'

function DashboardScreen() {
    return <>
        <Box className="p-4 bg-white rounded shadow border d-flex align-items-center textPrimary">
            <Box>
                <img src={logo} width={100} />
            </Box>
            <Box className="px-4">
                <Typography variant="h4"> Welcome to MCR <br /> (Mubashir Curtain)</Typography>
            </Box>
        </Box>
        <Box className="py-3">
            <Grid spacing={2} container>
                <Grid item md={6}>
                    <Box className="p-3 bgLight rounded shadow">
                        <Typography className="" variant="h5">Total Reciept</Typography>
                        <Typography className="textPrimary" variant="h4">786</Typography>
                    </Box>
                </Grid>
                <Grid item md={6}>
                    <Box className="p-3 bgLight rounded shadow">
                        <Typography className="" variant="h5">Total Balance</Typography>
                        <Typography className="textPrimary" variant="h4">23000</Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    </>
}
export default DashboardScreen